import React from "react";
import { FiLoader } from "react-icons/fi";
import { motion } from "framer-motion";

export default function LoadingComponent() {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-70 backdrop-blur-sm flex justify-center items-center z-50 px-4">
      <motion.div
        className="flex flex-col items-center bg-white rounded-3xl shadow-xl p-8 max-w-sm w-full"
        initial={{ opacity: 0, scale: 0.85, y: 20 }}
        animate={{
          opacity: 1,
          scale: 1,
          y: 0,
          transition: { duration: 0.5, ease: "easeOut" },
        }}
      >
        {/* Loader Icon */}
        <motion.div
          className="text-blue-600 text-7xl drop-shadow-md mb-6"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1.8, ease: "linear" }}
        >
          <FiLoader />
        </motion.div>

        {/* Loading text */}
        <motion.h2
          className="text-gray-800 text-2xl font-semibold mb-2 select-none"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          Loading, please wait...
        </motion.h2>

        {/* Subtext */}
        <motion.p
          className="text-gray-500 text-center text-sm mb-6 select-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          This might take a few seconds. Thank you for your patience.
        </motion.p>

        {/* Progress bar container */}
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden shadow-inner">
          {/* Animated progress bar */}
          <motion.div
            className="bg-blue-600 h-2 rounded-full"
            initial={{ width: 0 }}
            animate={{ width: "80%" }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut",
            }}
          />
        </div>
      </motion.div>
    </div>
  );
}
